import { StarrableEntitiesState } from "@/mk2/containers/Star/Star.reducers";
import { StarrableEntity, starKey } from "@/mk2/containers/Star/Star.schemas";
import { AppState } from "@/mk2/reducers";

interface State {
    entities: AppState["entities"];
}

export const getStarrable = (state: State, entity: string, id: number): StarrableEntity => {
    const substate = state.entities.starrable as StarrableEntitiesState;
    const key = starKey(entity, id);
    return (
        (substate && substate[key]) || {
            id,
            entity,
            isStarred: false,
            starsCount: 0,
            createdTime: null,
        }
    );
};
